<template>
  <div>
    <v-toolbar flat color="white" pt-4 mt-4>
      <v-btn round color="primary" @click="addItem()">Add Warehouse</v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="tableloading"
      class="elevation-1"
      :items="warehouses"
      item-key="id"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-icon @click="editItem(props.item)">edit</v-icon>
          <v-icon @click="deleteItem(props.item)">delete</v-icon>
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.name}}</td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-if="props.item.locationNetworkId!==null"
        >{{props.item.locationNetwork.name}}</td>
        <td @click="routerLinkToDetails(props.item)" v-else></td>
        <td @click="routerLinkToDetails(props.item)" v-if="props.item.locationNodeId!==null" class="text-xs-center" >
        {{props.item.locationNode.name}}</td>
        <td @click="routerLinkToDetails(props.item)" v-else></td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>

    <v-dialog v-model="addWarehouseModal" max-width="750px">
      <v-card flat color="white">
        <v-toolbar color="primary">
          <h1 class="headline white--text">ADD WAREHOUSE</h1>
        </v-toolbar>
        <v-card-text>
          <v-text-field label="Name" v-model="item.name"></v-text-field>
          <v-autocomplete
          v-model="item.locationNetworkId"
          :items="locationnetworks"
          item-text="name"
          item-value="id"
          label="Network"
          ></v-autocomplete>
          <v-autocomplete
          v-model="item.locationNodeId"
          :items="locationnodes"
          item-text="name"
          item-value="id"
          label="Node"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="addWarehouseModal=false, item={}">Cancel</v-btn>
            <v-btn round color="primary" v-if="item.name" @click="saveWarehouse">Save</v-btn>
            <v-btn round color="primary" v-else disabled>Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editWarehouseModal" max-width="750px">
      <v-card flat color="white">
        <v-toolbar color="primary">
          <h1 class="headline white--text">EDIT WAREHOUSE</h1>
        </v-toolbar>
        <v-card-text>
          <v-text-field label="Name" v-model="item.name"></v-text-field>
          <v-autocomplete
          v-model="item.locationNetworkId"
          :items="locationnetworks"
          item-text="name"
          item-value="id"
          label="Network"
          ></v-autocomplete>
          <v-autocomplete
          v-model="item.locationNodeId"
          :items="locationnodes"
          item-text="name"
          item-value="id"
          label="Node"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="editWarehouseModal=false, item={}">Cancel</v-btn>
            <v-btn round color="primary" v-if="item.name" @click="saveEditedWarehouse">Save</v-btn>
            <v-btn round color="primary" v-else disabled>Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
export default {
  props: ["warehouses", "locationnetworks", "locationnodes", "tableloading"],
  data() {
    return {
      addWarehouseModal: false,
      editWarehouseModal: false,
      item: {},
      headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Node",
          align: "center",
          value: "locationNode.name"
        }
      ]
    };
  },
  methods: {
    routerLinkToDetails(item) { 
      this.editedIndex = this.warehouses.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/inventoryWarehouseSummary/" + this.editedItem.id });  
    },
      editItem(item) {
        if(this.authUpdate(this.$store.state.currentRoute)){
      this.item = Object.assign({}, item);
      this.editWarehouseModal = true;
      }
    },
    deleteItem(item) {
        if(this.authDelete(this.$store.state.currentRoute)){
      confirm("Are you sure you would like to delete this warehouse?") &&
        Api()
          .put("/stockWarehouse/" + item.id, {
            isActive: false,
            isDeleted: true
          })
          .then(this.$emit("warehouseChange"));
        }
    },
    addItem(){
        if(this.authCreate(this.$store.state.currentRoute)){
            this.addWarehouseModal=true
        }
    },
    saveWarehouse() {
      Api()
        .post("/stockWarehouse", {
          name: this.item.name,
          locationNetworkId: this.item.locationNetworkId,
          locationNodeId: this.item.locationNodeId,
          isActive: true,
          isDelete: false
        })
        .then(() => {
          (this.addWarehouseModal = false),
            (this.item = {}),
            this.$emit("warehouseChange");
        });
    },
    saveEditedWarehouse() {
      Api()
        .put("/stockWarehouse/"+this.item.id, {
          name: this.item.name,
          locationNetworkId: this.item.locationNetworkId,
          locationNodeId: this.item.locationNodeId,
          isActive: true,
          isDelete: false
        })
        .then(() => {
          (this.editWarehouseModal = false),
            (this.item = {}),
            this.$emit("warehouseChange");
        });
    }
  }
};
</script>

<style>
</style>